const LEGACY_VILLAGES_CDN_BASE = "https://cdn.jsdelivr.net/gh/DevrajKalpure/PracticeGithub@main";
const DEFAULT_VILLAGES_CDN_BASE = `${LEGACY_VILLAGES_CDN_BASE}/data`;
const RAW_VILLAGES_BASE = "https://raw.githubusercontent.com/DevrajKalpure/PracticeGithub/main";
const RAW_VILLAGES_DATA_BASE = `${RAW_VILLAGES_BASE}/data`;
const LOCAL_VILLAGES_BASE = "/data";
const FETCH_TIMEOUT_MS = 15000;

function trimTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

function buildCandidates() {
  const configured = trimTrailingSlash(process.env.REACT_APP_VILLAGES_CDN_BASE || "");
  const candidates = [];

  if (configured) {
    if (configured.endsWith("/data")) {
      candidates.push(configured);
    } else {
      candidates.push(`${configured}/data`);
    }
  }

  // Prefer local /data first for instant response and avoiding rate limits
  candidates.push(LOCAL_VILLAGES_BASE, RAW_VILLAGES_DATA_BASE, DEFAULT_VILLAGES_CDN_BASE);

  return Array.from(new Set(candidates.map(trimTrailingSlash).filter(Boolean)));
}

function buildUrl(base, filePath) {
  return `${base}/${String(filePath || "").replace(/^\/+/, "")}`;
}

function slugify(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

async function buildStateReligionFallback(filePath) {
  const match = String(filePath || "").match(/^([^/]+)\/districtReligionData\.json$/);
  if (!match) return null;

  const stateSlug = match[1];
  const rootUrl = buildUrl(LOCAL_VILLAGES_BASE, "districtReligionData.json");
  const response = await fetchWithTimeout(rootUrl);
  if (!response.ok) return null;

  const payload = await response.json();
  const districts = (payload.districts || []).filter((row) => slugify(row.state) === stateSlug);
  if (!districts.length) return null;

  return new Response(JSON.stringify({ districts }), {
    status: 200,
    headers: { "Content-Type": "application/json; charset=utf-8" },
  });
}

async function fetchWithTimeout(url, init = {}, timeoutMs = FETCH_TIMEOUT_MS) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, {
      cache: "force-cache",
      ...init,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timer);
  }
}

export async function fetchVillageResponse(filePath, init = {}) {
  const candidates = buildCandidates();
  let lastError = null;

  for (const base of candidates) {
    const url = buildUrl(base, filePath);
    try {
      const response = await fetchWithTimeout(url, init);
      if (response.ok) return response;
      lastError = new Error(`HTTP ${response.status} for ${url}`);
    } catch (error) {
      lastError = error;
    }
  }

  const stateReligionFallback = await buildStateReligionFallback(filePath);
  if (stateReligionFallback) return stateReligionFallback;

  throw lastError || new Error(`Failed to fetch ${filePath}`);
}

export async function fetchVillageJson(filePath, init = {}) {
  const response = await fetchVillageResponse(filePath, init);
  return response.json();
}

export async function villageFileExists(filePath) {
  try {
    await fetchVillageResponse(filePath, { method: "HEAD" });
    return true;
  } catch (_) {
    return false;
  }
}

export function getVillageDataBase() {
  return buildCandidates()[0];
}
